import axios from 'api/api.config';
import qs from 'query-string';
import { useMutation } from 'react-query';

export function useExportAnalyticProduct() {
  return useMutation(({ queryFilter, bodyFilter }) =>
    axios.post(`/api/v1/admin/analytic-product/export?${qs.stringify(queryFilter)}`, bodyFilter).then((res) => res.data)
  );
}
